import React from "react";
import { string, node } from "prop-types";
import Block from "@insightfulscience/atomic-react/Block";
import { Col, Row } from "../../../Grid";
import ContentContainer from "../../atoms/ContentContainer";
import Link from "../../../Link";
import Image from "../../../Image";
import Paragraph from "../../../Paragraph";
import Heading from "../../../Heading";
import Section from "../../../Section";

const HomeNewAndNoteworthy = ({ children }) => {
	return (
		<Section utility={{ border: { bottom: { width: 1, color: "black--15" } } }} spacing={{ pb: 5 }}>
			<ContentContainer lg={10} center>
				{children}
			</ContentContainer>
		</Section>
	);
};

HomeNewAndNoteworthy.propTypes = {
	children: node.isRequired,
};

const HomeNewAndNoteworthyTitle = ({ children }) => {
	return (
		<Heading Tag="h2" sx={{ fontSize: "xl", textAlign: "center" }} spacing={{ mt: 20, mb: 20 }}>
			{children}
		</Heading>
	);
};

HomeNewAndNoteworthyTitle.propTypes = {
	children: string.isRequired,
};

const HomepageNewAndNoteworthyList = ({ children }) => {
	return children;
};

HomepageNewAndNoteworthyList.propTypes = {
	children: node.isRequired,
};

const HomepageNewAndNoteworthyListItem = ({ id, title, srcImg, href, children }) => {
	return (
		<Row id={id} spacing={{ mb: 20 }}>
			<Col lg={5}>
				<Block spacing={{ mb: 4, lg: { mb: 0 } }}>
					<Link href={href} isBaseClassName={false} utility={{ display: "block" }}>
						<Image src={srcImg} alt={title} />
					</Link>
				</Block>
			</Col>
			<Col lg={7}>
				<Block spacing={{ lg: { ml: 12 } }}>
					<Heading Tag="h3" sx={{ fontSize: "l" }} spacing={{ mt: "m1" }}>
						{title}
					</Heading>
					<Paragraph sx={{ fontSize: "m" }} spacing={{ mb: 2 }}>
						{children}
					</Paragraph>
					<Paragraph spacing={{ my: 0 }}>
						<Link href={href} isBaseClassName={false}>
							Learn More
						</Link>
					</Paragraph>
				</Block>
			</Col>
		</Row>
	);
};

HomepageNewAndNoteworthyListItem.propTypes = {
	id: string.isRequired,
	title: string.isRequired,
	srcImg: string.isRequired,
	href: string.isRequired,
	children: string.isRequired,
};

HomeNewAndNoteworthy.Title = HomeNewAndNoteworthyTitle;
HomeNewAndNoteworthy.List = HomepageNewAndNoteworthyList;
HomeNewAndNoteworthy.List.Item = HomepageNewAndNoteworthyListItem;

export default HomeNewAndNoteworthy;
